import React from "react";

export default function ElectricityIcon({ color = "currentColor", fill = "none", width = 13, height = 13 }) {
  return (
    <svg width={width} height={height} viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.125 0.875L6.625 5.375H12.625L5.875 12.125L6.625 7.625H1.375L8.125 0.875Z"
        stroke={color}
        fill={fill}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
